export const PROJECT_LIST_TABLE_HEAD = [
  { id: 'projectName', label: 'Name', alignRight: false },
  { id: 'clientName', label: 'Client', alignRight: false },
  { id: 'totalHrs', label: 'Project Budget Hours' },
  { id: 'total_time', label: 'Total spent Hours' },
  { id: 'Projectstatus', label: 'Project Budget Status' },
  { id: 'action', label: 'Action', sort: false },
  // { id: 'setting', label: '' },
];

export const INITIAL_PROJECT_FORM_STATE = {
  projectName: '',
  clientId: '',
  totalHrs: '',
  initialEstimatedHrs: '',
  allowOverSpent: false,
  allowManualTask: false,
  description: '',
  status: '',
  startDate: new Date(new Date().setHours(0, 0, 0, 0)),
  endDate: new Date(new Date().setHours(0, 0, 0, 0)),
  includeMe: true,
};

export const ADD_PROJECT_FORM_TITLE = 'Create A New Project';

export const EDIT_PROJECT_FORM_TITLE = 'Edit a Project';

export const EDIT_PARENT_TASK = ['Project Owner', 'Project Manager', "QA"];

export const INITIAL_PROJECT_MEMBER_FORM_STATE = {
  projectRoleId: '',
  userId: '',
  userHours: '',
  isActive: true,
  startDate: null,
};

export const TASK_STATUS_LIST = ['Not Started', 'In Progress', 'Completed', 'Blocked', 'Reopened'];

export const TASK_TYPE_LIST = ['Task', 'Issue', 'CR'];

export const TASK_STATUS_COLORS = {
  'not started': { text: '#161C24', background: '#DFE3E8' },
  completed: { text: '#188d1a', background: '#b3ffb3' },
  'in progress': { text: '#d49116', background: '#fff3bb' },
  blocked: { text: 'red', background: 'lightpink' },
  reopened: { text: '#0C53B7', background: '#D0F2FF' },
  'to do': { text: '#161C24', background: '#DFE3E8' },
  default: { text: 'inherit', background: 'transparent' },
};
